import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, DataTable } from "@msuite/ui/table";
import { formatNumber, getProgress } from "@msuite/utils/numbers";
import type { SuborderArticleListItem } from "@msuite/utils/types";

const columnHelper =
	createColumnHelper<
		Pick<SuborderArticleListItem, "quantity" | "pickedQuantity" | "openQuantity">
	>();

export const columns = [
	columnHelper.accessor("quantity", {
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => formatNumber(cell.getValue(), "integer"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("pickedQuantity", {
		id: "pickedQuantity",
		header: localized("stock.picked_quantity"),
		cell: (cell) => formatNumber(cell.getValue(), "integer"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("openQuantity", {
		id: "openQuantity",
		header: localized("stock.open_quantity"),
		cell: (cell) => formatNumber(cell.getValue(), "integer"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor((row) => getProgress(row.quantity, row.pickedQuantity), {
		id: "progress",
		header: localized("general.progress"),
		cell: (cell) => <DataTable.ProgressMeter value={cell.getValue()} />,
		size: 200,
	}),
];
